"use client";
import { jsxs as e, jsx as l } from "react/jsx-runtime";
const r = ({
  title: c,
  titleId: h,
  desc: i,
  descId: a,
  ...t
}) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 76",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    "aria-labelledby": h,
    "aria-describedby": a,
    ...t,
    children: [
      i ? /* @__PURE__ */ l("desc", { id: a, children: i }) : null,
      c ? /* @__PURE__ */ l("title", { id: h, children: c }) : null,
      /* @__PURE__ */ e("g", { fill: "none", fillRule: "evenodd", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#F4F4F4",
            d: "M111.999 0H8C3.582 0 0 3.59 0 8.008v59.984C0 72.415 3.591 76 8.001 76H112c4.419 0 8.001-3.59 8.001-8.008V8.008C120 3.585 116.409 0 111.999 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#227FBB",
            d: "M19.239 43.888c-.08-.053.475-2.193 1.8-6.932 1.053-3.77 2.045-7.297 2.202-7.838l.287-.982 4.141.076c4.842.088 5.587.152 6.366.546 1.38.699 1.76 1.773 1.285 3.634-.406 1.584-1.18 2.663-2.677 3.728-.284.202-.532.449-.55.548-.022.111.155.355.453.627.27.245.555.573.636.728.216.42.179 1.258-.122 2.713-.147.713-.295 1.732-.33 2.264l-.06.968h-2.005c-1.42 0-2.041-.036-2.13-.125-.196-.196-.152-.695.188-2.125.378-1.591.401-2.216.095-2.604-.403-.514-.77-.624-2.218-.673-1.17-.039-1.365-.021-1.542.139-.276.25-.5.894-1.154 3.321l-.556 2.067-1.996-.001c-1.098-.001-2.049-.036-2.113-.079m10.537-8.88c.951-.282 1.352-.903 1.354-2.096 0-.359-.06-.611-.183-.76-.289-.348-1.159-.466-2.791-.38l-1.419.077-.207.696c-.319 1.074-.542 2.113-.507 2.358.022.16.133.241.398.293.579.114 2.748-.008 3.355-.188m6.713 9.187c-.634-.226-1.133-.65-1.342-1.139-.398-.93-.032-2.998 1.421-8.029.348-1.204.633-2.202.633-2.216 0-.015.074-.1.164-.19.134-.135.44-.165 1.668-.165.827 0 1.62.044 1.763.098l.26.1-.259.92c-.636 2.26-1.297 5.002-1.41 5.859-.104.779-.1.985.023 1.243.281.587 1.302.71 2.17.264 1.019-.524 1.21-.973 2.847-6.684.24-.837.424-1.273.628-1.491l.289-.31h1.636c1.265 0 1.648.032 1.689.14.04.107-2.038 7.847-2.914 10.85l-.138.471-1.749.052c-.962.03-1.748.023-1.748-.013s.071-.267.158-.514c.354-1.003-.087-1.065-1.375-.196-1.273.859-1.806 1.062-2.908 1.109-.745.031-1.072-.003-1.506-.159m11.627-.31c-.093-.06.446-2.136 2.041-7.874l2.168-7.794 3.663.03c4.57.039 5.503.12 6.387.555.726.357 1.072.677 1.395 1.29.544 1.03.535 2.225-.029 3.864-.866 2.52-2.483 4.176-4.614 4.728-.345.09-1.428.21-2.407.269-3.233.193-3.038.157-3.211.6-.083.212-.406 1.293-.718 2.4l-.567 2.015-1.99-.001c-1.096-.001-2.048-.038-2.118-.082m9.426-8.389c1.065-.137 1.625-.466 1.98-1.163.382-.748.483-1.564.24-1.935-.332-.507-.787-.617-2.498-.608-.852.004-1.592.05-1.643.101-.117.118-.837 2.963-.837 3.309 0 .14.031.287.07.326.099.099 1.837.08 2.688-.03m5.981 8.742c-1.232-.516-1.552-1.369-1.15-3.073.561-2.381 1.798-3.177 6.044-3.891 2.564-.432 3.204-.747 3.388-1.669.137-.682-.448-1.054-1.655-1.056-.754 0-1.036.11-1.69.657l-.527.442-1.358.035c-1.573.04-2.057-.023-2.057-.266 0-.284.617-1.151 1.193-1.678.62-.566 1.44-1 2.328-1.23 1.864-.486 5.074-.43 6.177.108.59.288 1.115.766 1.365 1.244.236.452.152.921-.963 5.34-.547 2.17-.995 4.13-.995 4.356v.411H72.33c-.711 0-1.51.03-1.777.067l-.483.066-.213-.496c-.25-.583-.279-.583-1.595.01-1.429.642-1.953.786-3.063.838-.945.044-1.108.023-1.675-.215zm5.626-2.445c.721-.32 1.537-1.626 1.541-2.471l.003-.408-.665.062c-.736.07-2.292.571-2.862.923-.482.298-.764.778-.763 1.296.002.497.075.633.42.78.394.168 1.78.06 2.326-.182m5.764 7.133c-.42-.094-.435-.25-.144-1.4.39-1.538.365-1.506 1.33-1.656 1.04-.162 1.505-.39 1.737-.855.257-.515.238-2.535-.073-7.954-.173-3.016-.216-4.384-.14-4.475.078-.095.608-.13 1.972-.13h1.865l.033 3.5c.022 2.39.07 3.539.148 3.618.191.19.891-.994 3.761-6.36l.406-.758h1.646c.906 0 1.669.036 1.696.08.053.085-2.442 4.532-4.945 8.816-3.558 6.089-4.228 6.928-5.897 7.393-.545.152-2.955.28-3.395.181",
            opacity: 0.938
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#1AAF5D", d: "m90.338 47.53 4.893-17.924 4.658 9.263z" }),
        /* @__PURE__ */ l("path", { fill: "#F59D00", d: "m87.31 47.595 4.893-17.923 4.658 9.262z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#000",
            d: "M100.793 29.271v-1.222h-.465v-.213h1.172v.213h-.468v1.222h-.24Zm.867 0v-1.435h.352l.363 1.146.35-1.146h.345v1.435h-.218v-1.204l-.37 1.204h-.216l-.386-1.222v1.222z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            stroke: "#000",
            strokeWidth: 0.5,
            d: "M103.79 28.527a1.99 1.99 0 1 1-3.98 0 1.99 1.99 0 0 1 3.98 0Z",
            opacity: 0.938
          }
        )
      ] })
    ]
  }
);
export {
  r as default
};
